import { render, staticRenderFns } from "./SystemViewAlarmSetup.vue?vue&type=template&id=2490667e&scoped=true"
import script from "./SystemViewAlarmSetup.vue?vue&type=script&lang=ts"
export * from "./SystemViewAlarmSetup.vue?vue&type=script&lang=ts"
import style0 from "./SystemViewAlarmSetup.vue?vue&type=style&index=0&id=2490667e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2490667e",
  null
  
)

export default component.exports